import "./about-course.css";

import { Collapse } from "antd";
import { 
  PlayCircleOutlined 
} from "@ant-design/icons";

import { Link } from "react-router-dom";
import { useState } from "react";

const { Panel } = Collapse;

const ModelsAccordion = ({ data, courseHash }) => {
  const [activeKey, setActiveKey] = useState([]);

  const onChange = (keys) => {
    setActiveKey(keys);
  };

  return (
    <section style={{ padding: 10, backgroundColor: "#FFF", marginTop: 20 }}>
      <h2 style={{ marginBottom: 20, fontSize: 24, fontWeight: 600 }}>
        Módulos
      </h2>

      <Collapse 
        accordion={false}
        activeKey={activeKey} 
        onChange={onChange}
        expandIconPosition="end"
        style={{ backgroundColor: 'transparent', border: 'none' }}
      >
        {data?.map((module, index) => (
          <Panel
            key={module.id}
            header={
              <h3 style={{ 
                margin: 0, 
                fontSize: 18, 
                fontWeight: 600,
                color: '#000'
              }}>
                {module.name}
              </h3>
            }
            style={{
              marginBottom: 15,
              backgroundColor: '#fff',
              borderRadius: 8,
              border: '1px solid #e8e8e8',
              overflow: 'hidden',
            }}
          >
            <div style={{ 
              padding: '10px 20px',
              backgroundColor: '#fafafa' 
            }}>
              {module.lessons && module.lessons.length > 0 ? (
                <div>
                  <h4 style={{ 
                    marginBottom: 15, 
                    fontSize: 16, 
                    fontWeight: 600,
                    color: '#595959'
                  }}>
                    Aulas do Módulo ({module.lessons.length})
                  </h4>
                  {module.lessons.map((lesson, lessonIndex) => (
                    <Link
                      key={lesson.id}
                      to={`/mycourses/${courseHash}/modules/${module.hash}/lessons/${lesson.hash}`}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        padding: '12px 16px',
                        marginBottom: 8,
                        backgroundColor: '#fff',
                        borderRadius: 6,
                        textDecoration: 'none',
                        border: '1px solid #e8e8e8',
                        transition: 'all 0.3s',
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = '#1890ff';
                        e.currentTarget.style.boxShadow = '0 2px 8px rgba(24, 144, 255, 0.15)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = '#e8e8e8';
                        e.currentTarget.style.boxShadow = 'none';
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <div style={{ 
                          fontSize: 15, 
                          fontWeight: 500,
                          color: '#262626',
                          marginBottom: 2
                        }}>
                          {lesson.name}
                        </div>
                      </div>
                      <PlayCircleOutlined style={{ 
                        fontSize: 20, 
                        color: '#1890ff',
                        marginLeft: 10
                      }} />
                    </Link>
                  ))}
                </div>
              ) : (
                <div style={{ 
                  textAlign: 'center', 
                  padding: 20,
                  color: '#8c8c8c'
                }}>
                  Nenhuma aula cadastrada neste módulo
                </div>
              )}
            </div>
          </Panel>
        ))}
      </Collapse>

      {data?.length === 0 && (
        <div style={{ 
          textAlign: 'center', 
          padding: 40,
          backgroundColor: '#fafafa',
          borderRadius: 8,
          color: '#8c8c8c'
        }}>
          Nenhum módulo disponível para este curso
        </div>
      )}
    </section>
  );
};

export default ModelsAccordion;
